import React from 'react';
import TextInput from '../../form/TextInput';
import AddressControl from '../../form/AddressControl';
import User from "../../form/partner/user";
import Company from "../../form/partner/company";
import TextArea from "../../form/TextArea";
import List from "../../form/list";
import createForm from "./Form";
import Select from "../../form/Select";

class partnerForm extends React.Component {

    render() {
        const Control = this.props.values.component_type === 'company' ? Company : User;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <Control
                        value={this.props.values}
                        saveChanges={this.props.setFieldValue}
                        setFieldValue={this.props.setFieldValue}
                        fields={["taxid", "eu_taxid"]}
                        props={this.props.getFieldsProps(["taxid","eu_taxid"])}
                    />
                </div>
                <div className="row form-row">
                    <Control
                        value={this.props.values}
                        saveChanges={this.props.setFieldValue}
                        setFieldValue={this.props.setFieldValue}
                        fields={["group_taxid", "group_id"]}
                        props={this.props.getFieldsProps(["group_taxid", "group_id"])}
                    />
                </div>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <div className="row form-row">
                            <Control
                                value={this.props.values}
                                saveChanges={this.props.setFieldValue}
                                fields={["name"]}
                                props={this.props.getFieldsProps(["name"])}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <AddressControl
                        value={this.props.values.address}
                        label="Cím"
                        extrafields={["country"]}
                        saveChanges={this.props.setFieldValue}
                        {...this.props.getFieldProps("address")}
                    />
                </div>
                <div className="row form-row">
                    <Control
                        value={this.props.values}
                        saveChanges={this.props.setFieldValue}
                        fields={["telnum"]}
                        props={this.props.getFieldsProps(["telnum"])}
                    />
                    <Control
                        value={this.props.values}
                        saveChanges={this.props.setFieldValue}
                        fields={["email"]}
                        props={this.props.getFieldsProps(["email"])}
                    />
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            component="PartnerRole"
                            name="roles"
                            isMulti={true}
                            value={this.props.values.roles}
                            label="Státusz"
                            storeType="local"
                            objectValue={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextArea
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("comment.text")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <List
                            name="tradenames"
                            value={this.props.values.tradenames}
                            label="Gyártó nevek"
                            saveChanges={this.props.setFieldValue}
                            cols={[{field: "name"}]}
                            {...this.props.getFieldProps("tradenames")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(partnerForm);
